import { AfterViewInit, Component, ElementRef, HostListener, signal, ViewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavbarComponent } from "./component/navbar.component/navbar.component";
import { FooterComponent } from "./component/footer.component/footer.component";

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NavbarComponent, FooterComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements AfterViewInit {
  @ViewChild('cursorDot', { static: true })
  dotRef!: ElementRef<HTMLElement>;

  @ViewChild('cursorOutline', { static: true })
  outlineRef!: ElementRef<HTMLElement>;

  constructor() {
    
  }

  private setVisibility(visible: boolean) {
    const opacity = visible ? '1' : '0';
    this.dotRef.nativeElement.style.opacity = opacity;
    this.outlineRef.nativeElement.style.opacity = opacity;
  }

  ngAfterViewInit(): void {
    this.setVisibility(false);
  }

  // MOUSE MOVE
  @HostListener('document:mousemove', ['$event'])
  onMouseMove(e: MouseEvent) {
    const dot = this.dotRef.nativeElement;
    const outline = this.outlineRef.nativeElement;

    const dotHalf = dot.offsetWidth / 2;
    const outlineHalf = outline.offsetWidth / 2;

    dot.style.transform =
      `translate3d(${e.clientX - dotHalf}px, ${e.clientY - dotHalf}px, 0)`;

    outline.style.transform =
      `translate3d(${e.clientX - outlineHalf}px, ${e.clientY - outlineHalf}px, 0)`;

    if (dot.style.opacity !== '1') {
      this.setVisibility(true);
    }
  }

  // HOVERING ELEMENTS
  @HostListener('document:mouseover', ['$event'])
  onMouseOver(e: MouseEvent) {
    if ((e.target as HTMLElement).closest('a, button')) {
      document.body.classList.add('cursor-hover');
    }
  }

  @HostListener('document:mouseout', ['$event'])
  onMouseOut(e: MouseEvent) {
    if ((e.target as HTMLElement).closest('a, button')) {
      document.body.classList.remove('cursor-hover');
    }
  }

  // VISIBILITY
  @HostListener('document:mouseleave')
  onMouseLeave() {
    this.setVisibility(false);
  }

  @HostListener('document:mouseenter')
  onMouseEnter() {
    this.setVisibility(true);
  }
}